<div
  [class]="cardClass()"
  class="card h-full grow p-3xl bg-neutral-50 rounded-2xl">
  @if (iconComponent()) {
    <div class="card-icon mb-3xl">
      <ng-container [ngComponentOutlet]="iconComponent() ?? null" />
    </div>
  }

  <div class="card-title font-bold mb-sm text-primary-500 text-small">
    @if (title()) {
      <p>{{ title() }}</p>
    }
  </div>

  <div class="card-description text-neutral-700 text-small">
    @if (description()) {
      <p>
        {{ description() }}
      </p>
    }
  </div>

  <div class="card-points font-medium mt-xl text-extra-small text-neutral-700">
    @for (point of points(); track $index) {
      <p>- {{ point }}</p>
    }
  </div>
</div>
